// extracted by mini-css-extract-plugin
export default {"track":"Track_track__Hrvy7","info":"Track_info__GiC7e","trackinfo":"Track_trackinfo__NzDfZ","btns":"Track_btns__hizWp"};